import Vue from 'vue'
import Vuex from 'vuex'
import menu from './menu'
import user from './user'
import businessData from './businessData'
import message from './message'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    menu,
    user,
    businessData,
    message
  },
})



// WEBPACK FOOTER //
// ./src/store/index.js